package kz.dentalcrm.app.core.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.list_empty
import io.github.alexzhirkevich.compottie.LottieCompositionSpec
import io.github.alexzhirkevich.compottie.rememberLottieComposition
import io.github.alexzhirkevich.compottie.rememberLottiePainter
import kz.dentalcrm.app.theme.DefaultTheme
import org.jetbrains.compose.resources.stringResource

@Composable
fun UIEmptyListState(
    modifier: Modifier = Modifier,
    text: String = stringResource(Res.string.list_empty),
) {
    val composition by rememberLottieComposition {
        LottieCompositionSpec.JsonString(
            Res.readBytes("files/no_history.json").decodeToString()
        )
    }

    Column(
        modifier = modifier.fillMaxSize(),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Image(
            modifier = Modifier.size(120.dp),
            painter = rememberLottiePainter(
                composition = composition,
                iterations = Int.MAX_VALUE
            ),
            contentDescription = null
        )
        Spacer(modifier = Modifier.height(16.dp))
        Text(
            text = text,
            style = DefaultTheme.typography.bodyMediumRegular,
            color = DefaultTheme.colors.onSurface,
        )
    }
}
